import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlay,
  faUpRightFromSquare,
  faCopy,
  faShareNodes,
} from '@fortawesome/free-solid-svg-icons';
import './SketcherSetup.css';

interface Props {
  gameId: string;
  gameTitle: string;
  totalSketch: number;
  timeAllowed: number;
  gameCapacity: number;
}

const SketcherPublish: React.FC<Props> = ({
  gameId,
  gameTitle,
  totalSketch,
  timeAllowed,
  gameCapacity,
}) => {
  const navigate = useNavigate();
  const gameCode = String(gameId).toUpperCase();
  const [copied, setCopied] = useState(false);
  const [inviteEmail, setInviteEmail] = useState('');
  const [invitedPlayers] = useState<any[]>([]);

  const copyCode = () => {
    const baseUrl =
      process.env.REACT_APP_FRONTEND_URL || window.location.origin;
    const url = `${baseUrl}/join?gameId=${gameCode}`;
    navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="sketcher-pub">
      {/* Banner */}
      <div className="sketcher-pub__banner">
        <span className="sketcher-pub__banner-emoji">🎉</span>
        <div className="sketcher-pub__banner-text">
          <h2>Your sketcher game is ready!</h2>
          <p>{gameTitle} · Sketcher</p>
        </div>
        <div className="sketcher-pub__banner-actions">
          <button
            className="sketcher-pub__btn sketcher-pub__btn--primary"
            onClick={() => navigate(`/dashboard/games/game/${gameId}/lobby`)}
          >
            <FontAwesomeIcon icon={faPlay} /> Host Lobby
          </button>
          <button
            className="sketcher-pub__btn sketcher-pub__btn--outline"
            onClick={() => navigate('/dashboard/games')}
          >
            <FontAwesomeIcon icon={faUpRightFromSquare} /> My Games
          </button>
        </div>
      </div>

      <div className="sketcher-pub__body">
        {/* Left: Game code */}
        <div className="sketcher-pub__code-card">
          <span className="sketcher-pub__code-label">GAME CODE</span>
          <h1 className="sketcher-pub__code">{gameCode}</h1>
          <p className="sketcher-pub__code-sub">
            Share this code with players to join
          </p>
          <button
            className="sketcher-pub__btn sketcher-pub__btn--dark sketcher-pub__btn--full"
            onClick={copyCode}
          >
            <FontAwesomeIcon icon={faCopy} /> {copied ? 'Copied!' : 'Copy Code'}
          </button>
          <button className="sketcher-pub__btn sketcher-pub__btn--primary sketcher-pub__btn--full">
            <FontAwesomeIcon icon={faShareNodes} /> Share Invite Link
          </button>
        </div>

        {/* Right */}
        <div className="sketcher-pub__right">
          {/* Stats */}
          <div className="sketcher-pub__stats">
            <div className="sketcher-pub__stat">
              <span className="sketcher-pub__stat-val">{totalSketch}</span>
              <span className="sketcher-pub__stat-lbl">Sketches</span>
            </div>
            <div className="sketcher-pub__stat">
              <span className="sketcher-pub__stat-val">{timeAllowed}m</span>
              <span className="sketcher-pub__stat-lbl">Time/Sketch</span>
            </div>
            <div className="sketcher-pub__stat">
              <span className="sketcher-pub__stat-val">{gameCapacity}</span>
              <span className="sketcher-pub__stat-lbl">Max Players</span>
            </div>
          </div>

          {/* Invite */}
          <div className="sketcher-pub__invite">
            <div className="sketcher-pub__invite-header">
              <h4>Invite Players</h4>
              <span className="sketcher-pub__invite-count">
                👥 {invitedPlayers.length} invited
              </span>
            </div>
            <div className="sketcher-pub__invite-row">
              <input
                className="sketcher-pub__input"
                type="text"
                placeholder="Search by username or email..."
                value={inviteEmail}
                onChange={(e) => setInviteEmail(e.target.value)}
              />
              <button className="sketcher-pub__btn sketcher-pub__btn--primary">
                Invite
              </button>
            </div>
          </div>

          {/* QR */}
          <div className="sketcher-pub__qr">
            <div className="sketcher-pub__qr-icon">📱</div>
            <div className="sketcher-pub__qr-text">
              <h4>Share via QR Code</h4>
              <p>Players can scan to join instantly</p>
            </div>
            <button className="sketcher-pub__btn sketcher-pub__btn--outline">
              Generate QR
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SketcherPublish;
